import taxonomyAPIFactory from "../taxonomy/api"

const api = taxonomyAPIFactory({ taxonomyId: 'joint' })

export default api